/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Same_SkuInputs */

const en_po_issue_same_sku = /** @type {(inputs: Po_Issue_Same_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is the SKU the line already has`)
};

/**
* | output |
* | --- |
* | "is the SKU the line already has" |
*
* @param {Po_Issue_Same_SkuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_same_sku = /** @type {((inputs?: Po_Issue_Same_SkuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Same_SkuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_same_sku(inputs)
});